import type { NodePropertySchema } from '../../../types/node-properties';

const schema: NodePropertySchema = {
  nodeType: 'wait',
  version: '1.1.0',
  properties: [
    {
      key: 'amount',
      label: 'Amount',
      type: 'number',
      default: 1,
      required: true,
      description: 'The amount of time to wait',
      placeholder: '1',
      typeOptions: {
        minValue: 0,
        maxValue: 3600,
        numberPrecision: 0
      }
    },
    {
      key: 'unit',
      label: 'Unit',
      type: 'options',
      default: 'seconds',
      required: true,
      description: 'The unit of time',
      options: [
        {
          name: 'Milliseconds',
          value: 'milliseconds'
        },
        {
          name: 'Seconds',
          value: 'seconds'
        },
        {
          name: 'Minutes',
          value: 'minutes'
        },
        {
          name: 'Hours',
          value: 'hours'
        }
      ]
    }
  ]
};

export default schema;
